module.exports = __webpack_public_path__ + "static/media/right.7943e342.svg";